export interface IRule {
  [ruleType: string]: any;
}

export enum RuleType {
  REGEX = 'regex',
  ALPHA_NUMERIC = 'alphaNumeric',
  REQUIRED = 'required',
  EMAIL = 'email',
  MIN = 'min',
  BIRTH_DATE = 'birthDate',
  DATE_NOT_UNDEFINED = 'dateNotUndefined',
  DATE_NOT_EMPTY = 'dateNotEmpty',
  PHONE = 'phone',
  ISRAELI_ID = 'israeliId',
  DOES_NOT_MATCH_FIELD = 'doesNotMatchField',
  FIELD_PAIRS_ARE_UNIQUE = 'fieldPairsAreUnique',
}

export enum ValidationMode {
  LAZY = 'lazy',
  AGGRESSIVE = 'aggressive',
  PASSIVE = 'passive',
  EAGER = 'eager',
}

export interface InputProps {
  mode?: ValidationMode,
  name?: string,
  rules: IRule
}

export interface ValidationConfig {
  type: RuleType,
  message?: string;
}

export interface InputValidator {
  id: string;
  name: string;
  mode?: ValidationMode;
  rules: IRule;
}
